module.exports = __webpack_public_path__ + "static/bradesco-fe5244e0965cba7744451405ab938362.png";